import PropTypes from "prop-types";
import MatchProfilePropType from "./match-profile";

export default PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    matchProfile: MatchProfilePropType.isRequired,
});
